<div class="pkt-form-field" [class.pkt-error-state]="!!errorMessage">
  <label *ngIf="label" class="pkt-label">
    {{ label }}<span *ngIf="required" class="pkt-required">*</span>
  </label>

  <div *ngIf="showSelectAll" class="pkt-select-all">
    <mat-checkbox [checked]="allChecked" [indeterminate]="someChecked" [disabled]="disabled"
      (change)="onSelectAllChange($event.checked)">
      Select all
    </mat-checkbox>
    <span class="pkt-select-all-count" *ngIf="value.length > 0">({{ value.length }})</span>
  </div>

  <div class="pkt-checkbox-list" [class.horizontal]="orientation === 'horizontal'" [style.--cols]="columns > 1 ? columns : null">
    <div *ngFor="let opt of options" class="pkt-checkbox-item"
      [matTooltip]="opt.tooltip || ''"
      [matTooltipDisabled]="!opt.tooltip"
      matTooltipPosition="right">
      <mat-checkbox [checked]="isChecked(opt)" [disabled]="disabled || !!opt.disabled"
        (change)="onCheckChange(opt, $event.checked)">
        {{ opt.label }}
      </mat-checkbox>
      <span *ngIf="opt.hint" class="pkt-option-hint">{{ opt.hint }}</span>
    </div>
  </div>

  <div *ngIf="hint && !errorMessage" class="pkt-hint">{{ hint }}</div>
  <div *ngIf="errorMessage" class="pkt-error-msg">
    <span class="material-symbols-outlined">error</span>{{ errorMessage }}
  </div>
</div>